import React, { useState } from "react";
import { Button, Table, Form, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const STATUS_OPTIONS = [
  { value: "OF1", label: "Draft PU" },
  { value: "OF10", label: "Submitted PU" },
  { value: "OF100", label: "Selesai Sidang Fatwa" },
  { value: "OF280", label: "Dikembalikan Ke PU" },
  { value: "OF285", label: "Dikembalikan Oleh Komite Fatwa" },
  { value: "OF290", label: "Ditolak" },
  { value: "OF300", label: "Terbit SH" },
  { value: "OF56", label: "Pembayaran" },
  { value: "OF900", label: "Dibatalkan" },
];

const formatDateLocal = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const getDefaultDates = () => {
  const now = new Date();
  const start = new Date(now.getFullYear(), 0, 1);
  const end = now;
  return {
    tgl_dari: formatDateLocal(start),
    tgl_sampai: formatDateLocal(end),
  };
};

const _FILTER_KEY = "_daftar_pengajuan_state";

const DaftarPengajuan = () => {
  const navigate = useNavigate();
  const { tgl_dari, tgl_sampai } = getDefaultDates();
  const [startDate, setStartDate] = useState(tgl_dari);
  const [endDate, setEndDate] = useState(tgl_sampai);
  const [status, setStatus] = useState("OF300");
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [error, setError] = useState("");
  const [hasSearched, setHasSearched] = useState(false);

  const fetchData = async (tgl_dari, tgl_sampai, status) => {
    setLoading(true);
    setError("");
    setData([]);
    try {
      const res = await axios.get(
        `/api/daftar-pengajuan?tgl_dari=${tgl_dari}&tgl_sampai=${tgl_sampai}&status=${status}`,
      );
      if (res.data && res.data.status === "success") {
        setData(res.data.data || []);
        setFilteredData(res.data.data || []);
      } else {
        setError("Data tidak ditemukan atau response tidak sesuai.");
      }
    } catch (err) {
      setError(
        "Gagal mengambil data: " + (err.response?.data?.message || err.message),
      );
    } finally {
      setLoading(false);
      setHasSearched(true);
    }
  };

  const handleTampil = (e) => {
    e.preventDefault();
    fetchData(startDate, endDate, status);
    setSearchKeyword("");
  };

  const handleSearch = () => {
    if (!searchKeyword.trim()) {
      setFilteredData(data);
      return;
    }
    const keyword = searchKeyword.toLowerCase();
    const filtered = data.filter(
      (row) =>
        (row.no_daftar && row.no_daftar.toLowerCase().includes(keyword)) ||
        (row.nama_pu && row.nama_pu.toLowerCase().includes(keyword)) ||
        (row.kota_pu && row.kota_pu.toLowerCase().includes(keyword)) ||
        (row.prov_pu && row.prov_pu.toLowerCase().includes(keyword)) ||
        (row.jenis_usaha && row.jenis_usaha.toLowerCase().includes(keyword)) ||
        (row.nama_pendamping &&
          row.nama_pendamping.toLowerCase().includes(keyword)) ||
        (row.status_desc && row.status_desc.toLowerCase().includes(keyword)),
    );
    setFilteredData(filtered);
  };

  const handleResetSearch = () => {
    setSearchKeyword("");
    setFilteredData(data);
  };

  return (
    <div>
      <div
        style={{
          background:
            "linear-gradient(135deg, var(--primary-color) 0%, var(--primary-hover) 50%, var(--primary-dark) 100%)",
          color: "#fff",
          borderRadius: 16,
          padding: "24px 32px 20px 32px",
          marginBottom: 24,
          display: "flex",
          alignItems: "center",
        }}
      >
        <div style={{ fontSize: 40, marginRight: 24 }}>
          <i className="fas fa-list"></i>
        </div>
        <div>
          <div style={{ fontWeight: 700, fontSize: 28, lineHeight: 1.1 }}>
            Daftar Pengajuan
          </div>
          <div style={{ fontSize: 15, opacity: 0.9 }}>
            Daftar pengajuan lembaga berdasarkan filter tanggal dan status
          </div>
        </div>
      </div>
      <Form onSubmit={handleTampil} className="mb-3">
        <Row>
          <Col md={3}>
            <Form.Group controlId="startDate">
              <Form.Label>Tanggal Mulai</Form.Label>
              <Form.Control
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                required
              />
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group controlId="endDate">
              <Form.Label>Tanggal Akhir</Form.Label>
              <Form.Control
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                required
              />
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group controlId="status">
              <Form.Label>Status</Form.Label>
              <Form.Select
                value={status}
                onChange={(e) => setStatus(e.target.value)}
              >
                {STATUS_OPTIONS.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>
          <Col md={2} className="d-flex align-items-end">
            <Button type="submit" variant="primary" disabled={loading}>
              {loading ? "Memuat..." : "Tampil"}
            </Button>
          </Col>
        </Row>
      </Form>
      {error && hasSearched && (
        <div className="alert alert-danger">{error}</div>
      )}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div className="d-flex gap-2" style={{ flex: 1, maxWidth: 500 }}>
          <Form.Control
            type="text"
            placeholder="Cari berdasarkan No Daftar, Nama PU, Kota, Provinsi, Jenis Usaha, Pendamping, atau Status..."
            value={searchKeyword}
            onChange={(e) => setSearchKeyword(e.target.value)}
            onKeyPress={(e) => e.key === "Enter" && handleSearch()}
          />
          <Button variant="primary" onClick={handleSearch}>
            <i className="fas fa-search"></i> Cari
          </Button>
          <Button variant="secondary" onClick={handleResetSearch}>
            <i className="fas fa-undo"></i> Reset
          </Button>
        </div>
        <div className="text-muted">
          Total: {hasSearched ? filteredData.length : 0} data
        </div>
      </div>
      <Table striped bordered hover size="sm">
        <thead>
          <tr>
            <th>No</th>
            <th>No Daftar</th>
            <th>Nama PU</th>
            <th>Kota PU</th>
            <th>Provinsi PU</th>
            <th>Jenis Usaha</th>
            <th>Nama Pendamping</th>
            <th>Status</th>
            <th>Tgl Daftar</th>
            <th>Aksi</th>
          </tr>
        </thead>
        <tbody>
          {!hasSearched ? (
            <tr>
              <td colSpan={10} className="text-center">
                Pilih filter lalu klik Tampil untuk memuat data
              </td>
            </tr>
          ) : filteredData.length === 0 ? (
            <tr>
              <td colSpan={10} className="text-center">
                {loading ? "Memuat..." : "Tidak ada data"}
              </td>
            </tr>
          ) : (
            filteredData.map((row, idx) => (
              <tr key={row.id_reg || idx}>
                <td>{idx + 1}</td>
                <td>{row.no_daftar}</td>
                <td>{row.nama_pu}</td>
                <td>{row.kota_pu}</td>
                <td>{row.prov_pu}</td>
                <td>{row.jenis_usaha}</td>
                <td>{row.nama_pendamping}</td>
                <td>{row.status_desc}</td>
                <td>{row.tgl_daftar ? row.tgl_daftar.slice(0, 10) : ""}</td>
                <td>
                  {row.id_reg && (
                    <button
                      className="btn btn-outline-primary btn-sm py-0 px-2"
                      style={{ fontSize: "0.75rem" }}
                      onClick={() => {
                        sessionStorage.setItem(
                          _FILTER_KEY,
                          JSON.stringify({
                            startDate,
                            endDate,
                            status,
                            searchKeyword,
                          }),
                        );
                        const token = Math.random().toString(36).slice(2, 13);
                        localStorage.setItem(`_dreg_${token}`, row.id_reg);
                        navigate(
                          `/admin/pendamping/detail-registrasi/${token}`,
                        );
                      }}
                    >
                      <i className="fas fa-external-link-alt me-1"></i>
                      Detil
                    </button>
                  )}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </Table>
    </div>
  );
};

export default DaftarPengajuan;
